
import { Component, computed, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MultiSelectDropdownItem } from 'mis-crystal-design-system/multi-select-dropdown';
import { trigger, transition, style, animate } from '@angular/animations';
import { create } from "socketcluster-client";
import * as Highcharts from 'highcharts';
import SolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsMore from 'highcharts/highcharts-more';
// import { ThisReceiver } from '@angular/compiler';
import { CommonCabService } from '../../services/common-cab.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { Subscription, async, filter, take } from 'rxjs';
import { DateUtils } from 'src/app/utils/days-utils';
import { getOrdinal } from 'src/app/utils/helper-functions';
interface MarkerLabel extends google.maps.ReadonlyMarkerLabel {
  labelOrigin: google.maps.Point;
}

declare var require: any;
declare var InfoBox: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);



@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})

export class MapViewComponent implements OnInit, OnDestroy {
  imgSrc: string;
  Highcharts: typeof Highcharts = Highcharts;


  constructor(
    private dataService: DataService,
    private commonCabService: CommonCabService,
    private envService: EnvironmentService,
    private activeRoute: ActivatedRoute,
    private renderer: Renderer2
  ) { }
  socketRef: any;
  enableEmployeesDetails: boolean = false;
  employeesDetailsWithShuttleStops: any = []
  formControlValue = new UntypedFormControl("MOBILE");
  selectedActions: MultiSelectDropdownItem[] = [];
  actions: MultiSelectDropdownItem[] = [{ label: 'Vehicle Arrived', value: 'Vehicle Arrived' }, { label: 'Call Employee', value: 'Call Employee' }, { label: 'No Show', value: 'No Show' }];
  dataServiceSubscription:Subscription;
  polyline: google.maps.Polyline;
  map: google.maps.Map | undefined;
  // lat=12.900342
  // lng=77.790047
  // coordinates = new google.maps.LatLng(this.lat, this.lng);
  signInLocationCheck: boolean = false;
  signOutLocationCheck:boolean = false;
  enableTraffic: boolean = false
  enableSpeed: boolean = false
  selectedRadioValue = "MOBILE"
  mapOptions: google.maps.MapOptions =
    {
      // center:this.coordinates,
      zoom: 20,
      mapTypeControl: false,
      streetViewControl: false,
    };
  speedOnCard: any = 0
  lastLocationUpdate: any;
  speedColor: any = '#F2FBFF';
  socketLastUpdateTime = null;
  middleStopsCordinates: any = []
  allCordinates: any = []
  firstStop: any[]= [];
  lastStop: any ;
  vehicleMarker: google.maps.Marker | undefined | null;
  vehicleCurrentLocationCords: any;
  signInLocationGeoCords: any = []
  signInLocationMarkers: any = []
  signOutLocationMarkers:any = []
  noShowOnMapMarkers: any = []
  callEmployeesMarkersOnMap: any = []
  VehicleArrivedMarkersOnMap: any = []
  animationDuration: number = 3000;
  trafficLayer: google.maps.TrafficLayer;
  //stops: any;
  driverActions: any;
  employeeDetails: any;
  sequenceId: any = 0
  polylineList = [];
  mileStones: google.maps.DirectionsWaypoint[] = []
  formattedWaypoints: any = []
  formattedWaypointsBreakLine: any = []
  mapOfCoordsAndSpeed: any
  speedForMilestones: any = []
  vehiclePreviousCoords: any = { lat: 0, lng: 0 }
  legUUID = "8dd30b60-82f6-456a-8c4e-1000b83bf299"
  IMEI = "f696599b970c3ce6"
  cabRegnum=""
  options;
  speed;
  response;
  tripType:string = "Regular";
  actionsOpen = false;
  plannedRouteToggle = true;

  noShowAction = false;
  callEmployeeAction = false;
  vehicleArrivedAction = false;
  driverFixedDevice = false;
  planedRoutePath;
  currentStopIndex = 0;
  toolTip1;
  toolTip2;
  employeeInfo = false;
  isCompletedTrip = false;
  directionsRenderer = [];
  directionsService;
  routeConfig = [];
  infoBox;
  vehicleDetailsMarker = true;
  trackingInterval;
  loginLogoutStops = [];
  ETS_MASTER_PROPERTIES:any = {}
  isAvoidTolls=computed(()=>this.dataService.isAvoidTollsEnabled());

  ngOnInit(): void {
    this.setDefaultTab();
    this.imgSrc = this.envService.getImgSrc();
    this.legUUID = this.commonCabService.response.tripDetails.tripUuid
    this.IMEI = this.commonCabService.response.tripDetails.vehicle?.deviceDTO?.imei
    this.cabRegnum = this.commonCabService.response.tripDetails.vehicle?.vehicleIdentification
    this.response = this.commonCabService.response;
    this.tripType = this.response['tripDetails']['tripType'];
    console.log('common response', this.response);
    this.commonCabService.loginLogoutStops$.subscribe((res) => {
      this.loginLogoutStops = res;
    });

    if (this.response['tripDetails']['status'] === 'Ended') {
      this.isCompletedTrip = true;
      const ele = document.getElementById('highCharts');
      if (ele) {
        ele.style.display = 'none';
      }
    }
    if (this.response.tripDetails.vehicle !== null) {
      this.getTrackingSession();

      this.trackingInterval = setInterval(() => {
        this.getTrackingSession();
      }, 45000);

    }
    this.dataServiceSubscription = this.dataService.ETS_PROPERTIES$.subscribe((properties:any)=>{
      this.ETS_MASTER_PROPERTIES = properties;
    })

    this.commonCabService.driverActions$.subscribe((res: any) => {
      this.driverActions = res
    })
    // this.commonCabService.busStopsDetails$.subscribe((res: any) => {
    //   this.stops = res
    //   console.log("Shuttle Stops data with employees", this.stops);
    //   this.currentStopIndex = this.stops.findIndex((stop: any) => stop.actualArrivalTime === 0) - 1;
    //   console.log('current stop index', this.currentStopIndex);
    //   // if(this.currentStopIndex===-1){

    //   // }
    //   if (this.response['tripDetails']['status'] !== 'Ended') {
    //     const toolTip1content = `
    //     <div>
    //     <h3>${this.stops[this.currentStopIndex].address}</h3>
    //     <p>${this.stops[this.currentStopIndex].formattedPlannedArrivalTime} (+${this.stops[this.currentStopIndex].arrivalTimeDiffFormatted})</p>     
    //     </div>`;
    //     this.toolTip1 = new google.maps.InfoWindow({
    //       content: toolTip1content
    //     });
    //     const toolTip2content = `
    //     <div>
    //     <h3>${this.stops[this.currentStopIndex + 1].address}</h3>
    //     <p>ETA: ${this.stops[this.currentStopIndex + 1].formattedPlannedArrivalTime}</p>     
    //     </div>`;
    //     this.toolTip2 = new google.maps.InfoWindow({
    //       content: toolTip2content
    //     });
    //     this.toolTip1.open(this.map,)
    //   }



    //   // var marker1 = new google.maps.Marker({
    //   //   position: {lat: 12.920787, lng: 77.651444}, // Specify the marker's coordinates
    //   //   map: this.map
    //   // });
    //   // var marker1 = new google.maps.Marker({
    //   //   position: {lat: 37.7749, lng: -122.4194}, // Specify the marker's coordinates
    //   //   map: this.map
    //   // });  
    //   //const _this=this;
    //   // marker1.addListener('onload', function() {
    //   //   _this.toolTip1.open(_this.map, marker1);
    //   // });
    //   //  this.f(marker1);
    // })

    this.commonCabService.employeeDetails$.subscribe((res: any) => {
      this.employeeDetails = res
      console.log("employee details in Map", this.employeeDetails);
      this.allCordinates = this.employeeDetails.map((emp: {
        employees: any;
        unPlannedEmployeesOnStop: any;
        stopLocalityId: any;
        stopAddress: any,
        plannedArrivalTime: any,
        actualArrivalTime: any,
        address: any,
        localityId: any,
        actualPickUpLocation: any,
        plannedPickUpLocation: any,
        actualDropTime: any,
        actualPickupTime: any,
        plannedDropTimestamp: any,
        plannedPickupTimestamp: any,
        plannedDropLocation: any,
        actualDropLocation: any
        reportingTimeDriver:any,
        plannedPickupTime:any,
        signIn:any,
        signOut:any,
  

      }, index: number) => {
        const geocord = this.response['tripDetails']['direction'] === 'OUT' 
        ? (!!emp.plannedDropLocation?.address ? emp.plannedDropLocation.geocord : emp.actualDropLocation?.geocord)
        : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.geocord : emp.actualPickUpLocation?.geocord);
        if (!geocord) return null;
        const [lat, lng] = geocord.split(",");
        return {
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          plannedEmployees: { ...emp, serialNumber:(index + 1) }, 
          unplannedEmployees: emp,
          actualArrivalTimeOfStop: this.response['tripDetails']['direction'] === 'OUT' ? emp.signOut : emp.signIn,
          actualArrivalTimeOfStopInEpoch: this.response['tripDetails']['direction'] === 'OUT' ? emp.actualDropTime : emp.actualPickupTime,
          plannedArrivalTimeOfStop: this.response['tripDetails']['direction'] === 'OUT' ? emp.plannedPickupTime : emp.plannedPickupTime,
          address: this.response['tripDetails']['direction'] === 'OUT' ? (!!emp.plannedDropLocation?.address ? emp.plannedDropLocation.address : emp.actualDropLocation.address) : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.address : emp.actualPickUpLocation.address),
          localityId: this.response['tripDetails']['direction'] === 'OUT' ? (!!emp.plannedDropLocation?.address ? emp.plannedDropLocation.locationId : emp.actualDropLocation.locationId) : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.locationId : emp.actualPickUpLocation.locationId),
          driverReportingTime:emp.reportingTimeDriver,
          logType:this.response['tripDetails']['direction'] === 'OUT' ? 'Sign-Out' : 'Sign-In',
          serialNumber: index + 1, 
          geocord: this.response['tripDetails']['direction'] === 'OUT' 
          ? (!!emp.plannedDropLocation?.address ? emp.plannedDropLocation.geocord : emp.actualDropLocation.geocord) 
          : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.geocord : emp.actualPickUpLocation.geocord),
          sequenceNumber: index + 1, 
        };
      }).filter((emp: any) => emp !== null);
      
    this.middleStopsCordinates = Object.values(
      this.allCordinates.reduce((acc: any, stop: any) => {
        const key = stop.geocord;
        acc[key] = acc[key] || [];
        acc[key].push(stop); 
        return acc;
      }, {})
    ).map((group:any) => {
      const first = group[0];
      const last = group[group.length - 1];
    
      return {
        position: first.position,
        address: first.address,
        localityId: first.localityId,
        employeeCount: group.length,
        startSequenceNumber: first.sequenceNumber,
        endSequenceNumber: last.sequenceNumber,
        employees: group, // all employees at stop
      };
    });
    
    })





    // Remove first and last stops from allCordinates


    if (this.response['tripDetails']['direction'] === 'OUT') {
      this.firstStop = this.employeeDetails.map((emp: {
        employees: any;
        unPlannedEmployeesOnStop: any;
        stopLocalityId: any;
        stopAddress: any,
        plannedArrivalTime: any,
        actualArrivalTime: any,
        address: any,
        localityId: any,
        actualPickUpLocation: any,
        plannedPickUpLocation: any,
        actualDropTime: any,
        actualPickupTime: any,
        plannedDropTimestamp: any,
        plannedPickupTimestamp: any,
        plannedDropLocation: any,
        actualDropLocation: any


      }) => {
        const geocord = this.response['tripDetails']['direction'] === 'OUT' 
        ? (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.geocord : emp.actualPickUpLocation?.geocord) 
        : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.geocord : emp.actualPickUpLocation?.geocord);
      
        if (!geocord) return null;
        const [lat, lng] = geocord.split(",");
        return {
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          plannedEmployees: [],
          unplannedEmployees: [],
          actualArrivalTimeOfStop: emp.actualPickupTime,
          plannedArrivalTimeOfStop: emp.plannedPickupTimestamp,
          address: this.response['tripDetails']['direction'] === 'OUT' ? (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.address : emp.actualPickUpLocation.address) : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.address : emp.actualPickUpLocation.address),
          localityId: this.response['tripDetails']['direction'] === 'OUT' ? (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.locationId : emp.actualPickUpLocation.locationId) : (!!emp.plannedPickUpLocation?.address ? emp.plannedPickUpLocation.locationId : emp.actualPickUpLocation.locationId),        };
      }).filter((emp: any) => emp !== null);
    }

    console.log('map emp', this.firstStop);

    this.lastStop = this.allCordinates[this.allCordinates.length - 1];

    this.socketRef = create({
      port: 443,
      hostname: "sc.moveinsync.com",
      secure: true,
      autoReconnect: true,
      autoReconnectOptions: {
        initialDelay: 10000, //milliseconds
        randomness: 10000, //milliseconds
        multiplier: 1.5, //decimal
        maxDelay: 60000 //milliseconds
      },
    });
    const authListener = this.socketRef.listener("authStateChange").once();
    const connectListener = this.socketRef.listener("connect").once();
    connectListener.then(
      (data: { isAuthenticated: any }) => {
        console.log(data);
        if (!data.isAuthenticated) {
          this.socketRef.invoke("loginRequest", {
            username: "central-dashboard" + Math.random(),
            clientType: "mobileapp",
            organization: "central-dashboard",
          });
          console.log("Authenticated");
        } else {
          console.log("Connection established and authenticated with socket");
        }

      },
      (err: any) => {
        console.warn("error connecting socket >", err);
      }
    );

    this.subscribeToChannel()
      .then(() => {
        console.log("done");
      })
      .catch(() => {
        console.log("err");
      });

    //HighCharts
    this.options = {

      chart: {
        type: 'gauge',
        plotBackgroundColor: '#F2FBFF',
        plotBackgroundImage: '#F2FBFF',
        plotBorderWidth: 0,
        plotShadow: false,
        height: '60%'
      },

      title: {
        text: 'Last Updated: Just Now',
      },
      subtitle: {
        text: 'Speed:',
        useHTML: true
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%'
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 200,
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 15,
        tickWidth: 1,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '12px'
          }
        },
        lineWidth: 0,
        plotBands: [{
          from: 0,
          to: 120,
          color: '#55BF3B', // green
          thickness: 10
        }, {
          from: 120,
          to: 160,
          color: '#DDDF0D', // yellow
          thickness: 10
        }, {
          from: 160,
          to: 200,
          color: '#DF5353', // red
          thickness: 10
        }]
      },

      series: [{
        name: 'Speed',
        data: [0],
        tooltip: {
          valueSuffix: ' km/h'
        },
        dataLabels: {
          format: '{y} km/h',
          borderWidth: 0,
          color: (
            Highcharts.defaultOptions.title &&
            Highcharts.defaultOptions.title.style &&
            Highcharts.defaultOptions.title.style.color
          ) || '#333333',
          style: {
            fontSize: '12px',
            fontWeight: 'normal'
          }
        },
        dial: {
          radius: '80%',
          backgroundColor: 'gray',
          baseWidth: 10,
          baseLength: '0%',
          rearLength: '0%'
        },
        pivot: {
          backgroundColor: 'gray',
          radius: 4
        }

      }]

    };
    Highcharts.chart('container', this.options);

    setInterval(() => {
      const chart = Highcharts.charts[0];
      if (chart && !chart.renderer['forExport']) {

        const point = chart.series[0].points[0],

          inc = this.speedOnCard;



        point.y = 0;
        let newVal = point.y + (+inc);
        // if (newVal < 0 || newVal > 200) {
        //   newVal = point.y - inc;
        // }
        point.update(newVal);
      }

    }, 500);

  }

  checkFixedDeviceAvailability(){
    return !!this.commonCabService.response.tripDetails?.vehicle.externalDeviceImei
  }
  checkDriverDeviceAvailability(){
    return !!this.commonCabService.response.tripDetails?.vehicle.deviceDTO?.imei
  }

  async subscribeToChannel() {
    this.updateCabLocation(this.commonCabService.buid);
  }

  async updateCabLocation(buid: String) {
    var channelRef = this.socketRef.subscribe(this.IMEI);
    this.socketRef.listener("subscribe").once();
    for await (const socketData of channelRef) {

      // var locationUpdate = JSON.parse(socketData);
      console.log(socketData, "location update")
      if (socketData.message_type !== 'usercount') {
        let currentCords = { lat: socketData.data.la, lng: socketData.data.ln }
        if (this.vehiclePreviousCoords !== currentCords) {
          console.log("using socket animation", socketData.data.b);
          this.showSpeedTimeInfo(socketData.data.s)
          this.lastLocationUpdateOnCard(socketData.data.t)
          this.animatedMove(this.vehicleMarker, this.vehiclePreviousCoords, { lat: socketData.data.la, lng: socketData.data.ln }, socketData.data.b);
          //  Extending polly line (extend in formatted array reaponse)
          // let path = this.polyline.getPath();
          // let extendpoint = new google.maps.LatLng(socketData.data.la,socketData.data.ln);
          // path.push(extendpoint);
        }
        this.vehiclePreviousCoords = { lat: socketData.data.la, lng: socketData.data.ln }
        this.socketLastUpdateTime = socketData.data.t;
      }
      //  console.log("socket data",socketData);
    }
  }

  ngAfterViewInit() {
    this.mapInitializer();
    this.dataService.ETS_PROPERTIES_LOADED$.pipe(filter(Boolean), take(1))
    .subscribe(() => this.plotPlannedRoute());
  }

  prevMarker = null; // variable to keep track of the previously clicked marker
  isPrevMarkerClicked = false;

  attachMarkerAndMessage(marker: google.maps.Marker, map: google.maps.Map) {
    let selectedMarker: google.maps.Marker | null = null;
    //  const attachSecretMessage = (marker: google.maps.Marker, map: google.maps.Map) => {
    marker.addListener("click", () => {
      if (selectedMarker) {
        // Unselect the previously selected marker
        console.log('selectedMarker1', selectedMarker);

        const markerIcon1 = {
          url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        const markerIcon2 = {
          url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        selectedMarker.setIcon(selectedMarker['data'].actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1);
        this.employeesDetailsWithShuttleStops = []

      }
      if (selectedMarker === marker) {
        // If the same marker is clicked again, unselect it and clear the selectedMarker variable
        selectedMarker = null;
        console.log('selectedMarker2', marker);
        const markerIcon1 = {
          url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        const markerIcon2 = {
          url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        marker.setIcon(selectedMarker['data'].actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1);
        this.enableEmployeesDetails = false;
        this.employeesDetailsWithShuttleStops = []

        //  marker.setIcon("assets/icons/bus-stop-marker.svg");
      } else {
        // Select the new marker and update the selectedMarker variable
        this.employeesDetailsWithShuttleStops = []
        selectedMarker = marker;
        this.enableEmployeesDetails = true;
        this.employeesDetailsWithShuttleStops = marker.get("data");
        marker.setIcon(`${this.imgSrc}assets/icons/selected-marker-on-map.svg`);

        // Animate the map to the center of the clicked marker
        const position = marker.getPosition();
        if (position) {
          map.panTo(position);
        } else {
          console.error("Marker position is null or undefined");
        }
      }
    });
    // };
  }
  mapInitializer() {
    // if(this.response['tripDetails']['direction']==="OUT"){
    this.mapOptions = {
      center: this.response['tripDetails']['direction'] === "OUT" ? { lat: this.firstStop[0]?.position.lat(), lng: this.firstStop[0]?.position.lng() } : { lat: this.allCordinates[0]?.position.lat(), lng: this.allCordinates[0]?.position.lng() },
      zoom: 10,
      mapTypeControl: false,
      streetViewControl: false,
    }
    this.trafficLayer = new google.maps.TrafficLayer();
    //}
    this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, this.mapOptions);

    //Toltip on marker to display Data
    let selectedMarker: google.maps.Marker | null = null;



    const attachSecretMessage = (marker: google.maps.Marker, map: google.maps.Map) => {
      marker.addListener("click", () => {
        if (selectedMarker) {
          // Unselect the previously selected marker
          console.log('selectedMarker1', selectedMarker);
          this.toolTip2.close();

          // const markerIcon2 = {
          //   url: "assets/icons/stop-not-crossed-map1.svg", // URL to your custom marker icon image
          //   scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          //   labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          // };
          // const markerIcon3 = {
          //   url: "assets/icons/logout-office.svg", // URL to your custom marker icon image
          //   scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          //   labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          // };


          this.employeesDetailsWithShuttleStops = []

          this.enableEmployeesDetails = false;
        }
        if (selectedMarker === marker) {
          // If the same marker is clicked again, unselect it and clear the selectedMarker variable
          this.toolTip2.close();
          selectedMarker = null;
          console.log('selectedMarker2', marker);



          // const markerIcon2 = {
          //   url: "assets/icons/stop-not-crossed-map1.svg", // URL to your custom marker icon image
          //   scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          //   labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          // };
          // const markerIcon3 = {
          //   url: "assets/icons/logout-office.svg", // URL to your custom marker icon image
          //   scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          //   labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          // };



          this.enableEmployeesDetails = false;
          this.employeesDetailsWithShuttleStops = []

          //  marker.setIcon("assets/icons/bus-stop-marker.svg");
          } 
          else {
            selectedMarker = marker;
            this.enableEmployeesDetails = false;
          
            const stopData = marker.get("data");
            const employees = stopData?.employees ?? [];
            const empLength = employees.length;
            const isIrregular = this.tripType?.toLowerCase() === 'irregular';
            
            const rootDiv = this.renderer.createElement('div');
            this.renderer.addClass(rootDiv, 'InfoWindowPlanned');
            
            // Header
            const headerDiv = this.renderer.createElement('div');
            this.renderer.addClass(headerDiv, 'emp-header');
            const headerText = isIrregular
              ? `${employees[0]?.logType || 'Sign-In'} Details`
              : `${employees[0].logType} Details${empLength > 1 ? ` (${stopData.startSequenceNumber}-${stopData.endSequenceNumber})` : ''}`;
            
            const h3 = this.renderer.createElement('h3');
            this.renderer.appendChild(h3, this.renderer.createText(headerText));
            this.renderer.appendChild(headerDiv, h3);
            
            const closeImg = this.renderer.createElement('img');
            this.renderer.setAttribute(closeImg, 'id', `closeBtn-${stopData.startSequenceNumber}`);
            this.renderer.setAttribute(closeImg, 'src', `${this.imgSrc}assets/icons/cross-icon.svg`);
            this.renderer.addClass(closeImg, 'close-icon');
            this.renderer.appendChild(headerDiv, closeImg);
            this.renderer.appendChild(rootDiv, headerDiv);
            
            // Employees container
            const employeesContainer = empLength > 1 ? this.renderer.createElement('div') : rootDiv;
            if (empLength > 1) this.renderer.addClass(employeesContainer, 'employees-scrollable');
            
            employees.forEach((empStop: any, index: number) => {
              const emp = empStop.plannedEmployees;
              const plannedDropTime = emp.plannedDropTimestamp ? DateUtils.formatTime(emp.plannedDropTimestamp) : "--";
              const distance = emp.distance?.toFixed(2) || "0";
              
              const pickupDropNumber = emp.serialNumber || (index + 1);
              const directionLabel = this.response['tripDetails']['direction'] === 'OUT' ? ' Drop' : ' Pickup';
              const numberLabel = ` ${getOrdinal(pickupDropNumber)} ${directionLabel}`;
              
              const employeeDiv = this.renderer.createElement('div');
              this.renderer.addClass(employeeDiv, 'employee-details');
              if (emp.noShow) this.renderer.addClass(employeeDiv, 'no-show-employee');
              
              // Sub-header
              const subHeader = this.renderer.createElement('div');
              this.renderer.addClass(subHeader, 'sub-header');
              
              const nameContainer = this.renderer.createElement('div');
              this.renderer.addClass(nameContainer, 'name-container');
              
              const nameText = emp.noShow 
                ? `${emp.name || emp.Id} (No Show)`
                : `${emp.name} - ${emp.Id}`;
              this.renderer.appendChild(nameContainer, this.createSpan(nameText));
              this.renderer.appendChild(nameContainer, this.createSpan(numberLabel, 'label-no'));
              
              this.renderer.appendChild(subHeader, nameContainer);
              this.renderer.appendChild(employeeDiv, subHeader);
              
              // Values container
              const valuesDiv = this.renderer.createElement('div');
              this.renderer.addClass(valuesDiv, 'values');
              this.renderer.appendChild(valuesDiv, this.createSpan(`Planned Pickup: ${empStop.plannedArrivalTimeOfStop}`));
              
              if (!emp.noShow) {
                this.renderer.appendChild(valuesDiv, this.createSpan(`Planned Drop: ${plannedDropTime}`));
                this.renderer.appendChild(valuesDiv, this.createSpan(`${empStop.logType} Time: ${empStop.actualArrivalTimeOfStop}`));
              }
              
              this.renderer.appendChild(valuesDiv, this.createSpan(`Driver Reporting Time: ${empStop.driverReportingTime}`));
              this.renderer.appendChild(valuesDiv, this.createSpan(`Distance Travelled: ${distance} Km`));
              
              this.renderer.appendChild(employeeDiv, valuesDiv);
              this.renderer.appendChild(employeesContainer, employeeDiv);
              
              // Add HR separator if multiple employees
              if (employees.length > 1 && index < employees.length - 1) {
                this.renderer.appendChild(employeesContainer, this.renderer.createElement('hr'));
              }
            });
            
            if (empLength > 1) this.renderer.appendChild(rootDiv, employeesContainer);
          
            this.toolTip2 = new google.maps.InfoWindow({ content: rootDiv });
            this.toolTip2.open(map, marker);
          
            google.maps.event.addListenerOnce(this.toolTip2, "domready", () => {
              const btn = document.getElementById(`closeBtn-${stopData.startSequenceNumber}`);
              btn?.addEventListener("click", () => {
                selectedMarker = null;
                this.toolTip2.close();
              });
            });
          
            const position = marker.getPosition();
            if (position) map.panTo(position);
          }
          
          
      });
    };

    if (this.response['tripDetails']['direction'] === 'OUT') {
      const lat = this.firstStop?.[0]?.position?.lat?.();
      const lng = this.firstStop?.[0]?.position?.lng?.();
      if (lat  && lng) {
      let markerIcon3 = {
        url: `${this.imgSrc}assets/icons/logout-office.svg`, // URL to your custom marker icon image
        scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
        labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
      };
      var marker = new google.maps.Marker(
        {
          position: new google.maps.LatLng(parseFloat(lat.toString()), parseFloat(lng.toString())),
          map: this.map,
          icon: markerIcon3,
          animation: google.maps.Animation.DROP,
          label: {
            text: " ", // The number to be displayed on the marker
            color: "#035F6B", // Color of the label (number)
            fontSize: "14px", // Font size of the label (number)
            fontWeight: "bold", // Font weight of the label (number)
          },
        }
      );
    }
    }



    //Plotting Middle Stops
      console.log('middle stops', this.middleStopsCordinates);

      for (let stop of this.middleStopsCordinates) {
        // For irregular trips, show count for multiple employees, sequence number for single employee
        const isIrregular = this.tripType?.toLowerCase() === 'irregular';
        const labelText = isIrregular
          ? (stop.employeeCount > 1 ? `+${stop.employeeCount}` : `${stop.startSequenceNumber}`)
          : (stop.employeeCount > 1 
              ? `${stop.startSequenceNumber}-${stop.endSequenceNumber}` 
              : `${stop.startSequenceNumber}`);
        
        const labelLength = labelText.length;
        const needsLargeMarker = isIrregular 
          ? (stop.employeeCount > 1 ? stop.employeeCount >= 10 : stop.startSequenceNumber >= 10)
          : (stop.endSequenceNumber >= 10 || labelLength >= 4);
        
        const markerSize = needsLargeMarker ? 80 : 60;
        const labelOriginX = needsLargeMarker ? 40 : 30;
        const labelOriginY = needsLargeMarker ? 25 : 20;
        const fontSize = needsLargeMarker ? "12px" : "14px";

      const markerIcon = {
        url: `${this.imgSrc}assets/icons/planned-emp-cab-icon.svg`,
        scaledSize: new google.maps.Size(markerSize, markerSize),
        labelOrigin: new google.maps.Point(labelOriginX, labelOriginY),
      };

        const marker = new google.maps.Marker({
          position: stop.position,
          map: this.map,
          icon: markerIcon,
          animation: google.maps.Animation.DROP,
          label: {
            text: labelText,
            color: "#035F6B",
            fontSize: fontSize,
            fontWeight: "bold",
          },
        });
        marker.set("data", stop);
        attachSecretMessage(marker, this.map);
      }


    //Ploting  Last Stop
    if (this.response['tripDetails']['direction'] === "IN") {
      const lastMarkerIcon = {
        url: `${this.imgSrc}assets/icons/login-trip-stop-cab.svg`, // URL to your custom marker icon image
        scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
        labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
      };

      const officeLocations = new Set();
      const employees = this.response?.tripDetails?.employees ?? [];
      
      for (let i = 0; i < employees.length; i++) {
        const plannedDropLocation = employees[i]?.plannedDropLocation;
        if (plannedDropLocation && plannedDropLocation.localityGuid?.startsWith("LO")) {
          if (plannedDropLocation.geocord) {
            officeLocations.add(plannedDropLocation.geocord);
          } else {
            console.warn('geoCord is undefined for', plannedDropLocation.localityGuid);
          }
        }
      }
        console.log('143office locations', officeLocations);
      officeLocations.forEach((loc:string)=>{
        const [lat,lng] = loc.split(",").map(Number)
        const latLng = new google.maps.LatLng(lat,lng)
        const marker = new google.maps.Marker({
          position: latLng,
          map: this.map,
          icon: lastMarkerIcon,
          animation: google.maps.Animation.DROP,
          label: {
            text: " ", // The number to be displayed on the marker
            color: "#FFFFFF", // Color of the label (number)
            fontSize: "14px", // Font size of the label (number)
            fontWeight: "bold", // Font weight of the label (number)
          }
        })
      })


      // const [lat, lng] = this.response.tripDetails.plannedEndLocation.geocord.split(',').map(Number);
      // const myLatlng = new google.maps.LatLng(lat, lng);
      // const lastMarker = new google.maps.Marker(
      //   {
      //     position: myLatlng,
      //     map: this.map,
      //     icon: lastMarkerIcon,
      //     animation: google.maps.Animation.DROP,
      //     label: {
      //       text: " ", // The number to be displayed on the marker
      //       color: "#FFFFFF", // Color of the label (number)
      //       fontSize: "14px", // Font size of the label (number)
      //       fontWeight: "bold", // Font weight of the label (number)
      //     }
      //   });

    }

    // console.log('lastmarker', lastMarkerIcon, this.middleStopsCordinates.length, this.currentStopIndex);



    if (this.allCordinates.length === (this.currentStopIndex + 1) && this.response['tripDetails']['status'] !== 'Ended') {
      const toolTip2content = `
        <div>
        <h3>${this.employeeDetails[this.employeeDetails.length - 1]?.address}</h3>
        <p>ETA: ${this.employeeDetails[this.employeeDetails.length - 1]?.plannedSignIn}</p>     
        </div>`;
      this.toolTip2 = new google.maps.InfoWindow({
        content: toolTip2content
      });
      //  this.toolTip2.open(this.map, lastMarker);
    } else {

    }


  }
  openTooltip(marker) {
    marker.infoWindow.open(this.map, marker);
    // this.toolTip1.setPosition(marker.getPosition());
  }

  async getTrackingSession() {
    //creating polyline at first time
    this.commonCabService.getTrackingSession(this.legUUID, this.sequenceId, this.IMEI, this.selectedRadioValue, this.isCompletedTrip, this.driverFixedDevice).subscribe((res: any) => {

      let bearing = res.cabLocation?.mBearing
      this.speed = res.cabLocation?.mSpeed
      let updatedTime = res.cabLocation?.time
      this.sequenceId = res.sequenceId
      this.vehicleCurrentLocationCords = new google.maps.LatLng(res.cabLocation?.latitude, res.cabLocation?.longitude);
      let current = { lat: res.cabLocation?.latitude, lng: res.cabLocation?.longitude }
      this.lastLocationUpdateOnCard(updatedTime)
      if (!res.milestones) {
        res.milestones = [];
      }
      this.formattedWaypoints = res.milestones.map((obj: any) => new google.maps.LatLng(obj.latitude, obj.longitude));
      let breaklineCoords = res.milestones.map(
        (obj: any) => {
          return {
            loc: new google.maps.LatLng(obj.latitude, obj.longitude),
            timeStamp: obj.timeStamp,
            mSpeed: obj.mSpeed
          }
        }
      );
      for (let i = 0; i < breaklineCoords.length; i++) {
        this.formattedWaypointsBreakLine.push(breaklineCoords[i]);
      }
      console.log("this.formatted", this.formattedWaypointsBreakLine);






      if (this.vehicleMarker == null) {
        this.vehiclePreviousCoords = { lat: this.vehicleCurrentLocationCords.lat(), lng: this.vehicleCurrentLocationCords.lng() }
        const busImage = {
          url: `${this.imgSrc}assets/icons/cab-on-map.svg` + "#" + this.IMEI,
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(13, 13),
        };

        let tempURL = `${this.imgSrc}assets/icons/cross-icon.svg`;
        var boxText = `<div style="background: white;
        padding: 10px 0 10px 10px;
        width: max-content;
        border-radius: 10px;
        position: absolute;
        top: -50px;
        left: 10px;
        display:flex;
        gap:5px">
          <div style="display:flex;flex-direction:column">
          <span style="font-size:14px">Cab Number: ${this.response.tripDetails.vehicle?.vehicleIdentification}</span>
           
           <span style="font-size:14px">Driver: ${this.response.tripDetails.driver?.name}</span>
          </div>
          <img style="margin-top:-30px;cursor:pointer"  id="vehicleClose" src=${tempURL} />
           
         </div>`;
        var myOptions = {
          content: boxText,
          disableAutoPan: false,
          maxWidth: 0,
          pixelOffset: new google.maps.Size(-10, -10),
          zIndex: 2,
          boxStyle: { top: -10, left: -10 },
          closeBoxMargin: "",
          closeBoxURL: "",
          infoBoxClearance: new google.maps.Size(0, 0),
          isHidden: false,
          pane: "floatPane"
        };
        this.vehicleMarker = new google.maps.Marker(
          {
            position: this.isCompletedTrip ? this.lastStop?.position : this.vehicleCurrentLocationCords,
            map: this.map,
            icon: busImage
          });
        this.infoBox = new InfoBox(myOptions);
        //empMarker.marker.infoBox = infoBox;


        this.vehicleMarker.addListener('click', () => {
          // Open the InfoBox
          if (this.vehicleDetailsMarker) {
            this.infoBox.open(this.map, this.vehicleMarker);
            // this.vehicleDetailsMarker=false;
          } else {
            // this.infoBox.close();
            // this.vehicleDetailsMarker=true;
          }
        });
        this.infoBox.addListener('domready', () => {
          const infoBoxElement = document.getElementById('vehicleClose');
          // Add your click event logic here
          infoBoxElement.addEventListener('click', () => {
            // Your click event code
            this.infoBox.close();
          });
        });




        this.map?.setCenter(this.vehicleCurrentLocationCords);
        this.map?.setZoom(13);

        setTimeout(() => {
          let elemSel = document.querySelector(
            'img[src*="cab-on-map.svg"]'
          ) as HTMLElement;
          console.log(elemSel);

          if (elemSel && bearing != null) {
            elemSel.style.transform = `rotate(${bearing}deg)`;
          }
        }, 1000)
      } else {
        if (this.socketLastUpdateTime == null || this.socketLastUpdateTime < res.cabLocation?.time) {
          this.showSpeedTimeInfo(this.speed)
          this.lastLocationUpdateOnCard(updatedTime)
          console.log("using api animation");
          this.animatedMove(this.vehicleMarker, this.vehiclePreviousCoords, current, bearing);
          this.vehiclePreviousCoords = current;

          //   //HighCharts
          //   const chart = Highcharts.charts[0];
          // if (chart && !chart.renderer['forExport']) {
          // const point = chart.series[0].points[0],
          // inc = this.speedOnCard * 3.6;
          // console.log('speedOnCard',inc,this.speedOnCard);


          // let newVal = inc;
          // // if (newVal < 0 || newVal > 200) {
          // //   newVal = point.y - inc;
          // // }

          // point.update(newVal);
          // }
        }
      }
      this.plottingPolyLine(this.map)
    })
  }


  async animatedMove(
    marker: any,
    current: { lat: any; lng: any },
    moveto: { lat: number; lng: number },
    bearing: any
  ) {
    if (!marker || !current?.lat || !current?.lng || !moveto?.lat || !moveto?.lng) return;
    var imgIcon = marker.getIcon?.();
    if(imgIcon) {
    imgIcon.rotation = bearing;
    marker.setIcon(imgIcon);
    }
    var nxlat = moveto.lat;
    var nxlng = moveto.lng;
    var deltalat = (moveto.lat - current.lat) / 100;
    var deltalng = (moveto.lng - current.lng) / 100;
    for (var i = 0; i < 100; i++) {
      (function (ind) {
        setTimeout(function () {
          var newLat = marker.position?.lat();
          var newLng = marker.position?.lng();
          newLat += deltalat;
          newLng += deltalng;

          marker.setPosition({ lat: newLat, lng: newLng });
        }, 10 * ind);
      })(i);
    }
    marker.setValues({ lat: nxlat, lng: nxlng });
    let elemSel = document.querySelector(
      'img[src*="cab-on-map.svg"]'
    ) as HTMLElement;
    if (elemSel && bearing != null && bearing != 0) {
      elemSel.style.transform = `rotate(${bearing}deg)`;
    }
  }

  enableSpeedPolyline() {
    this.enableSpeed = !this.enableSpeed
    if (this.enableSpeed) {
      if (this.polyline) {
        this.polyline.setVisible(false);
      }
      this.drawPathWithSpeed(this.formattedWaypointsBreakLine, this.map)
    }
    else {
      for (let i = 0; i < this.polylineList.length; i++) {
        this.polylineList[i].setMap(null);
      }
      this.polylineList = []
      if (this.polyline) {
        this.polyline.setVisible(true);
      }
    }
    this.commonCabService.sendEvent("Speed Toggle Enabled", "mis_modern_trip_view", "speed_toggle", this.enableSpeed.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }
  
  lastLocationUpdateOnCard(time: any) {
    const currentTime = new Date().getTime(); // Get current time in milliseconds
    const timeDifferenceMinutes = Math.floor((currentTime - time) / (1000 * 60)); // Calculate the time difference in minutes

    if (timeDifferenceMinutes >= 0) {
      if (timeDifferenceMinutes === 0) {
        this.lastLocationUpdate = 'Just now';
      } else if (timeDifferenceMinutes <= 60) {
        this.lastLocationUpdate = `${timeDifferenceMinutes} min ago`;
      } else {
        const timeDifferenceHours = Math.floor(timeDifferenceMinutes / 60); // Calculate the time difference in hours
        const remainingMinutes = timeDifferenceMinutes % 60; // Calculate the remaining minutes

        if (remainingMinutes === 0) {
          this.lastLocationUpdate = `${timeDifferenceHours} hour ago`;
        } else {
          this.lastLocationUpdate = `${timeDifferenceHours} hour ${remainingMinutes} minutes ago`;
        }
      }
    }
  }
  showSpeedTimeInfo(speed) {

    this.speedOnCard = (speed * 3.6).toFixed(1)

    this.speedColor = '#F1FDF8';
    if (speed * 3.6 < 1) {
      this.speedColor = '#FAE1EA';
    }
  }

  plottingPolyLine(map: any) {
    this.polyline = new google.maps.Polyline({
      path: this.formattedWaypoints,
      geodesic: true,
      strokeColor: '#40447F',
      strokeOpacity: 2.0,
      strokeWeight: 3.5,
    });
    this.polyline.setMap(map);
  }

  drawPathWithSpeed(timeLocs, map) {
    for (let k = 0; k < timeLocs.length - 1; k++) {
      for (let m = k + 1; m < timeLocs.length; m++) {
        if (!timeLocs[k] || !timeLocs[m]) {
          break;
        }
        const path = [];
        path[0] = timeLocs[k].loc;
        path[1] = timeLocs[m].loc;

        const polylineOptions = {
          clickable: true,
          map: map,
          strokeColor: '#40447F',
          strokeOpacity: 1.0,
          strokeWeight: 2,
          path: path,
          time: timeLocs[m].timeStamp,
          speed: timeLocs[m].mSpeed,
        };
        this.polylineList.push(new google.maps.Polyline(polylineOptions));
        this.setPolyLineClickListener(this.polylineList[this.polylineList.length - 1]);
        k = m - 1;
        break;
      }
    }
  }


  setPolyLineClickListener(polyline) {
    const infoWindow = new google.maps.InfoWindow();
    const icon = {
      url: `${this.imgSrc}assets/icons/marker-on-polyline.svg`,
      scaledSize: new google.maps.Size(20, 20), // Adjust the size of the icon as needed
    };
    const marker = new google.maps.Marker({
      icon: icon,
      map: this.map,
      visible: false,
    });

    google.maps.event.addListener(polyline, 'mouseover', function (e) {

      if (!polyline.time) {
        return false;
      }

      const date=DateUtils.parseDateString(polyline.time, 'DD/MM/YYYY HH:mm:ss');
      const content = `
      <div class="d-flex flex-dir-col gap-4" style="padding: 2px;">
        <span> ${date.format('DD, MMMM, h:mm A')} </span>
        <span>Speed: ${(polyline.speed * 3.6).toFixed(1)} km/hr</span>
      </div>
    `;

      infoWindow.setContent(content);
      infoWindow.setPosition(e.latLng);
      infoWindow.setOptions({
        pixelOffset: new google.maps.Size(0, -30),

      });
      marker.setVisible(true);
      marker.setPosition(e.latLng);

      infoWindow.open(this.map);

      return true;
    });
    google.maps.event.addListener(polyline, 'mousemove', function (e) {
      marker.setVisible(true);
      marker.setPosition(e.latLng);
    });
    google.maps.event.addListener(polyline, 'mouseout', function (e) {
      infoWindow.close();
      marker.setVisible(false);
    });
  }


  plotSignInAndSignOutLocationMarkers(isSignIn: boolean) {
    const icon = {
      url: `${this.imgSrc}assets/icons/actual-emp-cab-icon.svg`,
      scaledSize: new google.maps.Size(50, 50),
      labelOrigin: new google.maps.Point(25, 19)
    };
  
    if (isSignIn) {
      const signInLocationGeoCordsMap = this.employeeDetails
        .filter((employee: any) => employee.actualPickupTime !== 0 && employee.actualPickUpLocation.geocord !== null)
        .map((employee: any) => {
          const [lat, lng] = employee.actualPickUpLocation.geocord.split(",");
          return {
            position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
            name: employee?.name,
            status: employee?.employeeTrackStatus,
            empId: employee?.Id,
            pickUp: employee?.plannedSignIn,
            signInLocation: employee?.actualPickUpLocation?.address,
            plannedLocation: employee?.plannedPickUpLocation?.address,
            empStatus: employee.adhoc ? 'ADHOC' : 'PLANNED',
            geocord: employee.actualPickUpLocation.geocord
          };
        });
  
      const signInGroupedByGeoCords = signInLocationGeoCordsMap.reduce((acc: any, employee: any) => {
        if (!acc[employee.geocord]) {
          acc[employee.geocord] = [];
        }
        acc[employee.geocord].push(employee);
        return acc;
      }, {});
  
      let activeMarker: any;
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      const infowindow = new google.maps.InfoWindow({ zIndex: 999 });

      for (let geocord in signInGroupedByGeoCords) {
        const group = signInGroupedByGeoCords[geocord];
        const markerPosition = group[0].position;
  
        group.forEach((employee: any, index: number) => {
          const marker = new google.maps.Marker({
            position: markerPosition,
            map: this.map,
            icon: icon, 
            animation: google.maps.Animation.DROP,
            label: {
              text: (index + 1).toString(),
              zIndex: 2,
              color: '#C13D6D',
              fontSize: '12px',
              fontWeight: 'bold',
              fontFamily: 'Lato',
              labelOrigin: new google.maps.Point(25, 15)
            } as MarkerLabel
          });
  
          const groupInfo = group.map((emp: any) => {
            return `
              <div class="employee-details">
                <div class="employee-header">
                  <span class="employee-name"><b>${emp?.name}</b></span>
                  <span class="planned-color">Planned</span>
                </div>
                <div class="employee-info">
                  <div><b>Employee ID:</b> ${emp.empId}</div>
                  <div><b>Pick up:</b> ${emp.pickUp}</div>
                  <div><b>Signed In At:</b> ${emp.signInLocation}</div>
                  <div><b>Planned:</b> ${emp.plannedLocation}</div>
                </div>
                <hr class="divider"/>
              </div>
            `;
          }).join('');
  
          marker.addListener('click', () => {
            tooltip.innerHTML = `
              <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
                ${groupInfo}
              </div>
            `;
  
            if (activeMarker === marker) {
              infowindow.close();
              activeMarker = null;
              return;
            }
  
            activeMarker = marker;
            infowindow.setContent(tooltip);
            infowindow.open(this.map, marker);
          });
          this.signInLocationMarkers.push(marker)
        });
      }
    }
  
    else {
      const signOutLocationGeoCordsMap = this.employeeDetails
        .filter((employee: any) => employee.actualDropTime !== 0 && employee.actualDropLocation.geocord !== null)
        .map((employee: any) => {
          const [lat, lng] = employee.actualDropLocation.geocord.split(",");
          return {
            position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
            name: employee?.name,
            status: employee?.employeeTrackStatus,
            empId: employee?.Id,
            dropLocation: employee?.actualDropLocation?.address,
            dropTime: new Date(employee?.actualDropTime).toLocaleString(),
            dropTimeEpoch: employee?.actualDropTime,
            empStatus: employee.adhoc ? 'ADHOC' : 'PLANNED',
            geocord: employee.actualDropLocation.geocord
          };
        })
    
      const icon = {
        url: `${this.imgSrc}assets/icons/actual-emp-cab-icon.svg`,
        scaledSize: new google.maps.Size(50, 50),
        labelOrigin: new google.maps.Point(25, 19)
      };
    
      let activeMarker: any;
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      const infowindow = new google.maps.InfoWindow({ zIndex: 999 });
    

      signOutLocationGeoCordsMap.forEach((employee: any, index: number) => {
        const marker = new google.maps.Marker({
          position: employee.position,
          map: this.map,
          icon: icon, 
          animation: google.maps.Animation.DROP,
          label: {
            text: (index + 1).toString(), 
            zIndex: 2,
            color: '#3A6A4B',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'Lato',
            labelOrigin: new google.maps.Point(25, 15)
          } as MarkerLabel
        });
    
        const groupInfo = `
          <div class="employee-details">
            <div class="employee-header">
              <span class="employee-name"><b>${employee?.name}</b></span>
              <span class="completed-color">Completed</span>
            </div>
            <div class="employee-info">
              <div><b>Employee ID:</b> ${employee.empId}</div>
              <div><b>Drop Time:</b> ${employee.dropTime}</div>
              <div><b>Dropped At:</b> ${employee.dropLocation}</div>
            </div>
            <hr class="divider"/>
          </div>
        `;
    
        marker.addListener('click', () => {
          tooltip.innerHTML = `
            <div class="sign-out-employees-tooltip d-flex flex-dir-col gap-8">
              ${groupInfo}
            </div>
          `;
    
          if (activeMarker === marker) {
            infowindow.close();
            activeMarker = null;
            return;
          }
    
          activeMarker = marker;
          infowindow.setContent(tooltip);
          infowindow.open(this.map, marker);
        });
    
        this.signOutLocationMarkers.push(marker);
      });
    }
  }


  removeSignInLocationMarkers(isSignIn:boolean) {
    if(isSignIn){
      for (let i = 0; i < this.signInLocationMarkers.length; i++) {
        this.signInLocationMarkers[i].setMap(null);
      }
      this.signInLocationMarkers = [];
    }else{
      for (let i = 0; i < this.signOutLocationMarkers.length; i++) {
        this.signOutLocationMarkers[i].setMap(null)
      }
      this.signOutLocationMarkers = [];
    }
  }


  employeesDetailsToggler() {
    this.enableEmployeesDetails = !this.enableEmployeesDetails
  }


  onClosePopup(d: { value: boolean, data: any }) {
    this.enableEmployeesDetails = d.value;
    console.log('marker data', d);
    const markerIcon1 = {
      url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
    };

    const markerIcon2 = {
      url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
    };
    const stop = this.middleStopsCordinates.filter((item) => { item.address === d.data.address });

    var marker = new google.maps.Marker(
      {
        position: stop.position,
        map: this.map,
        icon: stop.actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1,
        animation: google.maps.Animation.DROP,
        label: {
          text: '' + 1, // The number to be displayed on the marker
          color: "#FFFFFF", // Color of the label (number)
          fontSize: "14px", // Font size of the label (number)
          fontWeight: "bold", // Font weight of the label (number)
        },
      }
    );


  }

  enableTafficToggler() {
    this.enableTraffic = !this.enableTraffic;

    if (this.enableTraffic) {
      this.trafficLayer.setMap(this.map);
    } else {
      this.trafficLayer.setMap(null);
    }
    this.commonCabService.sendEvent("Traffic Enabled ", "mis_modern_trip_view", "traffic_toggle", this.enableTraffic.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }

  showPlannedRoute() {
    this.plannedRouteToggle = !this.plannedRouteToggle;

    if (this.plannedRouteToggle) {
      this.plotPlannedRoute();
    } else {
      console.log('rempve [plannen3');

      this.removePlannedRoute();
    }
    this.commonCabService.sendEvent("Planned Route Enabled", "mis_modern_trip_view", "planned_route_toggle", this.plannedRouteToggle.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }

  showSignInLocationToggler() {
    this.signInLocationCheck = !this.signInLocationCheck;
    if (this.signInLocationCheck) {
      this.plotSignInAndSignOutLocationMarkers(true);
    } else {
      this.removeSignInLocationMarkers(true);
    }
    this.commonCabService.sendEvent("Sign In Locations Enabled", "mis_modern_trip_view", "sign_in_locations", this.signInLocationCheck.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }

  showSignOutLocationToggler(){
    this.signOutLocationCheck = !this.signOutLocationCheck
    if (this.signOutLocationCheck) {
      this.plotSignInAndSignOutLocationMarkers(false);
    }
    else{
      this.removeSignInLocationMarkers(false);
    }
  }

  radioSelect(value: any) {
    this.selectedRadioValue = value
  }

  selectedItems(values: any) {
    const previousSelection = this.selectedActions;
    this.selectedActions = values;

    // Remove markers for previously selected values that are not selected anymore
    previousSelection.forEach((action) => {
      if (!this.selectedActions.some(newAction => newAction.value === action.value)) {
        switch (action.value) {
          case 'No Show':
            this.removeNoShowMarkersOnMap();
            break;
          case 'Vehicle Arrived':
            this.removeVehicleArrivedMarkersOnMap();
            break;
          case 'Call Employee':
            this.removeplotCallEmployeeMarkersOnMap();
            break;
          default:
            break;
        }
      }
    });

    // Add markers for newly selected values
    this.selectedActions.forEach((action) => {
      switch (action.value) {
        case 'No Show':
          this.plotNoShowMarkerOnMap();
          break;
        case 'Vehicle Arrived':
          this.plotVehicleArrivedMarkersOnMap();
          break;
        case 'Call Employee':
          this.plotCallEmployeeMarkersOnMap();
          break;
        default:
          break;
      }
    });
  }

  unselectedValue(value) {
    switch (value) {
      case 'No Show':
        this.noShowAction = false;
        this.removeNoShowMarkersOnMap();
        this.commonCabService.sendEvent("No Show Toggle Enabled", "mis_modern_trip_view", "no_show_toggle", this.noShowAction.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
        break;
      case 'Vehicle Arrived':
        this.vehicleArrivedAction = false;
        this.removeVehicleArrivedMarkersOnMap();
        this.commonCabService.sendEvent("Vehicle Arrived Toggle Enabled", "mis_modern_trip_view", "vehicle_arrived_toggle",  this.vehicleArrivedAction.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
        break;
      case 'Call Employee':
        this.callEmployeeAction = false;
        this.removeplotCallEmployeeMarkersOnMap();
        this.commonCabService.sendEvent("Call Employee Toggle Enabled", "mis_modern_trip_view", "call_employee_toggle", this.callEmployeeAction.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
        break;
      default:
        break;
    }
  }

  selectedValue(value) {
    switch (value) {
      case 'No Show':
        this.noShowAction = true;
        this.plotNoShowMarkerOnMap();
        this.commonCabService.sendEvent("No Show Toggle Enabled", "mis_modern_trip_view", "no_show_toggle", this.noShowAction.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
        break;
      case 'Vehicle Arrived':
        this.vehicleArrivedAction = true;
        this.plotVehicleArrivedMarkersOnMap();
        this.commonCabService.sendEvent("Vehicle Arrived Toggle Enabled", "mis_modern_trip_view", "vehicle_arrived_toggle",  this.vehicleArrivedAction.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
        break;
      case 'Call Employee':
        this.callEmployeeAction = true;
        this.plotCallEmployeeMarkersOnMap();
        this.commonCabService.sendEvent("Call Employee Toggle Enabled", "mis_modern_trip_view", "call_employee_toggle", this.callEmployeeAction.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
        break;
      case 'Fixed Device':
        this.selectedRadioValue = "FIXED_DEVICE";
        this.driverFixedDevice = true;
        this.getTrackingSession()
        break;
      case 'Driver App':
        this.selectedRadioValue = 'MOBILE';
        this.driverFixedDevice = false;
        this.getTrackingSession()
        break;
      default:
        break;
    }
  }


  plotNoShowMarkerOnMap() {
    // Extract all the geoCode values
    const noShowGeoCodesMap = (Array.isArray(this.driverActions.noShowDriverActions) ? this.driverActions.noShowDriverActions : []).map((obj: any) => {
      if (!obj?.geoCode) return null;
      const [lat, lng] = obj.geoCode.split?.(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj?.empName, employeeId: obj?.empId,markedAt: DateUtils.formatDateTime(obj?.markedAt,"hh:mm"), plannedAt: obj?.plannedLocation?.address, markedBy: obj?.markedBy };
    }).filter((item: any) => item !== null);
    console.log("mapping object", noShowGeoCodesMap);

    const icon = {
      url: `${this.imgSrc}assets/icons/no-show-on-map.svg`,
    };
    for (let i = 0; i < noShowGeoCodesMap.length; i++) {
      const marker = new google.maps.Marker({
        position: noShowGeoCodesMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
      });
      let openTooltip: any = null;
      // Create a custom tooltip for each marker
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerHTML = `
      <div class="no-show-tooltip d-flex flex-dir-col gap-8">
      <div class="d-flex flex-dir-col">
          <span class="h7-b">${noShowGeoCodesMap[i].empName}</span>
          <span class="red">No Show</span>
      </div>
      <div class="d-flex flex-dir-col">
          <span class="h7">Employee ID:${noShowGeoCodesMap[i]?.employeeId}</span>
          <span class="h7">Marked at:${noShowGeoCodesMap[i]?.markedAt}</span>
          <span class="h7">Planned at:${noShowGeoCodesMap[i]?.plannedAt}</span>
          <span class="h7">Marked by:${noShowGeoCodesMap[i]?.markedBy}</span>
      </div>
    </div>
      `;

      // Add the tooltip to the marker on click event
      marker.addListener('click', () => {
        // Check if a tooltip is already open and close it if it's the same marker
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        } else {
          // Create a new tooltip and open it
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });
      this.noShowOnMapMarkers.push(marker);
    }
  }

  plotPlannedRoute() {

    this.commonCabService.employeeDetails$.subscribe((res) => {
      console.log('shuttle plan', res);
      this.routeConfig = [];

      // if(this.directionsRenderer){
      this.directionsRenderer.forEach((item) => {
        item.setMap(null);
      })
      this.directionsRenderer = [];
      //  delete this.directionsRenderer;
      // }
      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer.push(new google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: '#CC006B', 
          strokeOpacity: 0,
          zIndex: 1,
          icons: [{
            icon: {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              strokeWeight: 2,
              scale: 3
            },
            offset: '0',
            repeat: '15px' // Set the dash length and gap length here
          }],
        }
      }));

      if (this.response['tripDetails']['direction'] === 'OUT' && res.length && res[0].plannedPickUpLocation?.geocord) {
        // office lat lng
        const geocord = res[0].plannedPickUpLocation.geocord;
        const [lat, lng] = geocord.split(',');
        this.routeConfig.push({ lat: lat, lng: lng });
      }

      res = res.filter((el:any)=> (!el.adhoc))

      res.forEach((emp) => {
        const geocord = this.response['tripDetails']['direction'] === 'OUT' 
        ? emp.plannedDropLocation?.geocord
        : ((emp.adhoc || emp.escort) ? emp.actualPickUpLocation?.geocord : emp.plannedPickUpLocation?.geocord);
        
        if (geocord) {
        const [lat, lng] = geocord.split(',');
        this.routeConfig.push({ lat: lat, lng: lng });
        }
      })
      if (this.response['tripDetails']['direction'] === 'IN') {
        for (let i = 0; i < res.length; i++) {
          if (res[i].adhoc === false && res[i].escort === false && res[i].plannedDropLocation?.geocord) {
            const [lat, lng] = res[i].plannedDropLocation.geocord.split(',');
            this.routeConfig.push({ lat: lat, lng: lng });
            break;
          }

        }
      }

      const waypointsData = this.routeConfig.map((waypoint) => ({
        location: new google.maps.LatLng(waypoint.lat, waypoint.lng)
      }));
      const origin = waypointsData[0];
      const dest = waypointsData[waypointsData.length - 1];
      waypointsData.shift();
      waypointsData.pop();

      const request = {
        origin: origin,
        destination: dest,
        waypoints: waypointsData,
        travelMode: google.maps.TravelMode.DRIVING,
        optimizeWaypoints: true,
        avoidTolls: this.isAvoidTolls(),
      };
      const _this = this;
      this.directionsService.route(request, function (response, status) {
        if (status === 'OK') {
          // _this.directionsRenderer.setDirections(response);
          _this.draw(response);
        } else {
          console.log('Directions request failed. Status:', status);
        }
      });



      // this.planedRoutePath = new google.maps.Polyline({
      //   path: this.routeConfig,
      //   strokeColor: '#0000FF', // Blue color
      //   strokeOpacity: 0.8,
      //   strokeWeight: 2,
      //   icons: [{
      //     icon: {
      //       path: 'M 0,-1 0,1',
      //       strokeOpacity: 2,
      //       scale: 4
      //     },
      //     offset: '0',
      //     repeat: '20px' // Set the dash length and gap length here
      //   }],
      //   map: this.map
      // });
      //  this.planedRoutePath.setMap(this.map);
      // this.calculateRoute(routeConfig);

    });
    // const map = new google.maps.Map(document.getElementById('map'));

  }

  calculateRoute(coOr) {

    for (let i = 1; i < coOr.length; i++) {
      const request = {
        origin: coOr[i - 1], // Start point
        destination: coOr[i], // End point
        travelMode: google.maps.TravelMode.DRIVING, // Use driving directions
      };
      const _this = this;
      // Request the directions
      this.directionsService.route(request, function (response, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          _this.draw(response);
        }
      });
    }

  }
  draw(res) {
    // for (let i = 0; i < legs.length; i++) {
    //   const steps = legs[i].steps;

    //   for (let j = 0; j < steps.length; j++) {
    //     const polyline = new google.maps.Polyline({
    //       path: steps[j].path,
    //       strokeColor: '#10ADAE',
    //       strokeOpacity: 0,
    //       strokeWeight: 8,
    //       icons: [{
    //         icon: {
    //           path: 'M 0,-2 0,2',
    //           strokeOpacity: 1,
    //           scale: 3,
    //         },
    //         offset: '0',
    //         repeat: '30px', // Set the distance between dashes
    //       }],
    //       map: this.map,
    //     });
    //   }

    this.directionsRenderer[0].setDirections(res);
    // }




    // const polylineOptions = {

    //   strokeColor: "#0000FF",
    //   strokeOpacity: 0.8,
    //   strokeWeight: 4,
    //   icons: [{
    //     icon: {
    //       path: 'M 0,-1 0,1',
    //       strokeOpacity: 1,
    //       scale: 4,
    //     },
    //     offset: '0',
    //     repeat: '20px', // Set the distance between dashes
    //   }],
    // };
    // const rendererOptions = {
    //   draggable: false,
    //   map: this.map,
    //   suppressMarkers: true,
    //   suppressInfoWindows: true,
    //   preserveViewport: true,
    //   suppressBicyclingLayer: true,
    //   polylineOptions
    // };
    // const directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions);
    // directionsDisplay.setDirections(route);

    // this.planedRoutePath.push(directionsDisplay);
  }


  removePlannedRoute() {

    console.log(typeof (this.directionsRenderer));

    if (this.directionsRenderer) {
      this.directionsRenderer[0].setMap(null);
    }
    // this.planedRoutePath=null;
  }

  plotCallEmployeeMarkersOnMap() {
    // Extract all the geoCode values
    const callEmployeesGeoCodesMap = Array.isArray(this.driverActions.callEmployeeDriverActions)?
    this.driverActions.callEmployeeDriverActions?.filter((obj: any) => obj && obj.geoCode)
    ?.map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj.empName, empId: obj.empId, pickUp:DateUtils.formatDateTime(obj.pickUpTime,"hh:mm") ,
        callNumber: obj.phoneNumber, 
        callStart: DateUtils.formatDateTime(obj.callStartTime,"hh:mm"),
        callDuration: obj.callDuration, callStatus: obj.callStatus };
    }) : [];
    console.log("call employees", callEmployeesGeoCodesMap);

    const icon = {
      url: `${this.imgSrc}assets/icons/call-employee-marker-on-map.svg`,
    };

    for (let i = 0; i < callEmployeesGeoCodesMap.length; i++) {
      const marker = new google.maps.Marker({
        position: callEmployeesGeoCodesMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
      });
      // Create a custom tooltip for each marker
      let openTooltip: any = null;
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      let callNumber = '';
      tooltip.innerHTML = `
        <div class="call-employee-tool-tip d-flex flex-dir-col gap-8">
        <div class="d-flex flex-dir-col">
            <span>${callEmployeesGeoCodesMap[i].empName}</span>
            <span>${callEmployeesGeoCodesMap[i].callStatus}</span>
        </div>
        <div class="d-flex flex-dir-col">
            <span>Employee ID:${callEmployeesGeoCodesMap[i].empId}</span>
            <span>Pickup:${callEmployeesGeoCodesMap[i].pickUp}</span>
            <span>Call number:${this.showHiddenPhoneNumber(callEmployeesGeoCodesMap[i].gender,callEmployeesGeoCodesMap[i].callNumber)}</span>
            <span>Call Start:${callEmployeesGeoCodesMap[i].callStart}</span>
            <span>Call Duration:${callEmployeesGeoCodesMap[i].callDuration}</span>
        </div>
     </div>
        `;
      marker.addListener('click', () => {
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        }
        else {
          // Create a new tooltip and open it
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });

      this.callEmployeesMarkersOnMap.push(marker);
    }
  }

  showHiddenPhoneNumber(gender, phone){
    const isVendor = this.dataService.isVendorRole();
    const hidePhoneForVendors = this.ETS_MASTER_PROPERTIES?.HIDE_EMP_PHONE_NO_FROM_VENDORS;
    const hiddenInfoText = this.ETS_MASTER_PROPERTIES?.TEXT_SHOWN_FOR_HIDDEN_INFO_TO_VENDORS;
    const shouldHidePhone = () => {
      if (!isVendor) return false;
      
      switch (hidePhoneForVendors) {
          case 'All employees':
              return true;
          case 'Female employees only':
              return gender === 'Female';
          case 'Disabled':
              return false;
          default:
              return false;
      }
    };
    return shouldHidePhone() ? hiddenInfoText : phone
  }



  plotVehicleArrivedMarkersOnMap() {
    const arrivedActions = Array.isArray(this.driverActions?.vehicleArrivedDriverActions)
    ? this.driverActions?.vehicleArrivedDriverActions
    : [];
    // Extract all the geoCode values
    const VehicleArrivedMarkersOnMap = arrivedActions
    ?.filter((obj: any) => obj && obj.geoCode)
    .map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj.empName, vehicleArrived: DateUtils.formatDateTime(obj.vehicleArrivedAt,"hh:mm"), status: obj.vehicleStatusWithTime };
    });

    // const icon = {
    //   url: 'assets/icons/vehicle-arrived-marker-on-map.svg',
    // };
    const icon = {
      url: `${this.imgSrc}assets/icons/vehicle-arrived-marker-on-map.svg`, // URL to your custom marker icon image
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(40, 40), // Position of the label (number) relative to the marker icon
    };
    for (let i = 0; i < VehicleArrivedMarkersOnMap.length; i++) {
      const marker = new google.maps.Marker({
        position: VehicleArrivedMarkersOnMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
      });
      // Create a custom tooltip for each marker
      let openTooltip: any = null;
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerHTML = `
        <div class="vehicle-arrived-tooltip d-flex flex-dir-col gap-8">
        <span>${VehicleArrivedMarkersOnMap[i].status}</span>
        <span>Vehicle arrived at ${VehicleArrivedMarkersOnMap[i].vehicleArrived}</span>
        </div>
        `;

      marker.addListener('click', () => {
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        }
        else {
          // Create a new tooltip and open it
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });
      this.VehicleArrivedMarkersOnMap.push(marker);
    }
  }

  removeNoShowMarkersOnMap() {
    if (this.noShowOnMapMarkers) {
      for (let i = 0; i < this.noShowOnMapMarkers.length; i++) {
        this.noShowOnMapMarkers[i].setMap(null);
      }
      this.noShowOnMapMarkers = [];
    }
  }

  removeVehicleArrivedMarkersOnMap() {
    for (let i = 0; i < this.VehicleArrivedMarkersOnMap.length; i++) {
      this.VehicleArrivedMarkersOnMap[i].setMap(null);
    }
    this.VehicleArrivedMarkersOnMap = [];
  }

  removeplotCallEmployeeMarkersOnMap() {
    for (let i = 0; i < this.callEmployeesMarkersOnMap.length; i++) {
      this.callEmployeesMarkersOnMap[i].setMap(null);
    }
    this.callEmployeesMarkersOnMap = [];
  }

  ngOnDestroy(): void {
    this.dataServiceSubscription.unsubscribe();
    this.socketRef.unsubscribe(this.IMEI);
    clearInterval(this.trackingInterval);
  }


  tabs:any[] = ['Legacy','Modern'];
  setDefaultTab(){
    this.activeRoute.url.subscribe((url) => {
      this.defaultTab = url[0].path === 'trip-view' ? 'Modern' : 'Legacy';
    })
  }
  defaultTab = 'Modern'
  handleSelectedTab(event: any) {
    this.commonCabService.sendEvent("Legacy Switch Enabled", "mis_modern_trip_view", "legacy_switch", event === 'Legacy' ? 'true' : 'false',this.commonCabService.buid, new Date().toISOString().split('T')[0]);
    event === 'Legacy' ? this.openLegacy() : ''
  }

  openLegacy()  {
    setTimeout(() => {
      window.parent.location.href = this.commonCabService.createOldRoute();
    }, 200);
  }
  handleDriverAction(){
    this.actionsOpen = !this.actionsOpen
    this.commonCabService.sendEvent("Driver Actions Expanded ", "mis_modern_trip_view", "driver_actions_expand",this.actionsOpen.toString(),this.commonCabService.buid, new Date().toISOString().split('T')[0]);
  }

  checkETSMasterProperty(toggleType : 'no-show' | 'call-employee' | 'vehicle-arrived'){
    switch(toggleType){
      case 'call-employee' : 
        return !this.ETS_MASTER_PROPERTIES['FEATURE_CLICK2CALL_ENABLED']
      case 'no-show' : 
        return !this.ETS_MASTER_PROPERTIES['ENABLE_NO_SHOW_EMPLOYEE_NOTIFICATION']
      case 'vehicle-arrived' : 
        return !this.ETS_MASTER_PROPERTIES['ENABLE_CAB_ARRIVED'];
      default : 
        return '';
    }
   
  }

  private createSpan(text: string, className?: string): HTMLElement {
    const span = this.renderer.createElement('span');
    if (className) this.renderer.addClass(span, className);
    this.renderer.appendChild(span, this.renderer.createText(text));
    return span;
  }
  
}